// Angular
import { Pipe, PipeTransform } from '@angular/core';
// External
@Pipe({
    name: 'handicap'
})

export class HandicapPipe implements PipeTransform {

    transform(value: any, ...args: any[]): any {
       
        return String(value).replace("-", "+")


        // return moment(value).format(args[0]);
    }
}
